export const MOBILE_PAGE_CONFIG = {
  name: 'MetricConfig',
  className: 'dbb-explore-metric-detail',
  children: [
    {
      name: 'CommonHeader',
      config: {
        title: {
          name: 'MetricDetailTitle',
          config: {
            subTitle: 'For any questions, contact {{name}}.',
            subTitleCn: '如有问题，请联系 {{name}}。',
          },
        },
        operationList: {
          name: 'MetricDetailOperation',
          config: {
            title: 'Is this benchmark useful for you?',
            titleCn: '该Benchmark对您是否有用？',
            api: '/api/v2/dashboard/benchmark/metric/expansion/info',
            clickApi: '/api/v2/dashboard/benchmark/metric/expansion',
            dataKey: 'like',
          },
        },
      },
      children: [
        {
          name: 'CommonContantWrap',
          config: {
            logConfig: {
              typeId: 'benchmark_mobile',
              uid: "",
              uidType: "",
              pageId: '800301',
              pageName: 'benchmarkExploreMobileMetricDetail',
              extInfo: {
                metricKey: '{{metricKey}}',
                metricNameEn: '{{metricNameEn}}',
                metricNameCn: '{{metricNameCn}}',
              },
              pagePath: '/benchmark/mobile/explore/metricIaa',
            },
          },
          children: [
            {
              "name": "MetricDetailTips",
              "className": "",
              "style": { "marginTop": "20px" },
              "props": {
                "config":
                    {
                      "titleEn": "DataBrain Tips",
                      "titleCn": "DataBrain Tips"
                    },
              }
            },
            {
              name: 'MetricDetailGroupService',
              props: {
                api: '/api/v2/dashboard/benchmark/metric_info'
              },
              children: [
                {
                  name: 'MetricDetailCardService',
                  props: {
                    filterLoading: false,
                    config: {
                      api: '/api/v2/dashboard/benchmark/metric',
                    },
                  },
                  children: [
                    {
                      name: 'CommonRow',
                      className: '',
                      type: 'layout',
                      style: {
                        "margin": "20px 0px 18px"
                      },
                      props: {},
                      children: [
                        {
                          "name": "MetricDetailCardContext",
                          "props": {
                            "config": {
                              "subTitleKey": 'game_contributors',
                              "sourceTitleEn": "Data Source:",
                              "sourceTitleCn": "数据源：",
                              "rightTextKey": 'last_update_date',
                              "contentsTitles":
                                    [
                                      {
                                        "titleEn": 'Top 1%',
                                        "titleCn": '前1%',
                                        "className": 'dbb-top-1',
                                        "style": {},
                                        "rainbowKey": 'Benchmark Top 1',
                                        "bubble": '',
                                        'value': 'top1%',
                                        'dataKey': 'top1per_text'
                                      },
                                      {
                                        "titleEn": 'Top 10%',
                                        "titleCn": '前10%',
                                        "className": 'dbb-top-10',
                                        "style": {},
                                        "rainbowKey": 'Benchmark Top 10',
                                        "bubble": '',
                                        'value': 'top10%',
                                        'dataKey': 'top10per_text'
                                      },
                                      {
                                        "titleEn": 'Median',
                                        "titleCn": '中位数',
                                        "className": 'dbb-median',
                                        "style": {},
                                        "rainbowKey": 'Benchmark Median',
                                        "bubble": '',
                                        'value': 'median_text',
                                        'dataKey': 'median_text'
                                      },
                                      {
                                        "titleEn": '',
                                        "titleCn": '',
                                        "className": 'dbb-otdr',
                                        "style": {},
                                        "rainbowKey": 'Benchmark GTDR',
                                        "titleTipPlacement": 'top-end',
                                        'value': 'otdr',
                                        'dataKey': 'otdr',
                                        'isHaveValueExplain': true
                                      },
                                    ],
                              "chartConfig": {
                                "seriesConfig": [
                                  {
                                    "nameEn": "Median",
                                    "nameCn": "中位数",
                                    "dataKey": "median_text",
                                    "color": "#69D19C",
                                    "skipFormat": true
                                  }
                                ]
                              }
                            }
                          }
                        }
                      ],
                    },
                  ],
                }
              ]
            },
          ],
        },
      ],
    },
  ],
};
